import { render, staticRenderFns } from "./PartnerNew.vue?vue&type=template&id=2e012388&scoped=true&"
import script from "./PartnerNew.vue?vue&type=script&lang=js&"
export * from "./PartnerNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e012388",
  null
  
)

export default component.exports